module.exports = __webpack_public_path__ + "img/Akshay.b723bc39.png";